const Jewelry = [
  {
    category: "jewelry",
    subcategory: "Montres connectées",
    name: "Global Version Xiaomi Mi bande 5",
    price: "42.99",
    raw_price: "99.99",
    currency: "USD",
    discount: "57",
    likes_count: "27",
    is_new: "false",
    brand: "XIAOMI",
    brand_url: "https://fr.newchic.com/xiaomi-brand-520.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/4B/90/7bf3cce7-803e-4f11-b7cb-5dff0fbc4147.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/4B/90/7bf3cce7-803e-4f11-b7cb-5dff0fbc4147.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D8/0C/320c8c02-ae39-4298-a9d6-5950756aa391.jpg",
    url: "https://fr.newchic.com/xiaomi-smart-watches-4993/p-1692610.html",
    id: "1692610",
    model: "SKUE46513",
  },
  {
    category: "jewelry",
    subcategory: "Colliers",
    name: "Collier long pendentif géométrique",
    price: "17.61",
    raw_price: "33.55",
    currency: "USD",
    discount: "48",
    likes_count: "518",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/9C/A8/e17e8307-43cc-43f0-ba4c-333342a450e3.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/necklaces-4047/p-1513785.html",
    id: "1513785",
    model: "SKUC71348",
  },
  {
    category: "jewelry",
    subcategory: "Montres connectées",
    name: "Montre intelligente ECG EKG",
    price: "66.29",
    raw_price: "166.14",
    currency: "USD",
    discount: "60",
    likes_count: "505",
    is_new: "false",
    brand: "Bakeey",
    brand_url: "https://fr.newchic.com/bakeey-brand-878.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Rose",
    variation_1_color: "rouge",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/F3/3D/f0161af0-0149-4e83-a5c9-b0cfc9a91016.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F3/3D/f0161af0-0149-4e83-a5c9-b0cfc9a91016.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/FB/A3/84d81e8e-2756-44ec-be4a-b0a17b65c75f.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/FB/A3/84d81e8e-2756-44ec-be4a-b0a17b65c75f.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E4/6D/a686b80f-9d52-4f7c-8ea5-2ce371358e60.gif",
    url: "https://fr.newchic.com/bakeey-smart-watches-4993/p-1409396.html",
    id: "1409396",
    model: "SKUA96208",
  },
  {
    category: "jewelry",
    subcategory: "Colliers",
    name: "Collier à pampilles blanc",
    price: "9.99",
    raw_price: "24.99",
    currency: "USD",
    discount: "60",
    likes_count: "140",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E4/0D/cf1a0f56-ba62-4f6d-8de0-953bcc9c3975.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/necklaces-4047/p-1689722.html",
    id: "1689722",
    model: "SKUF37878",
  },
  {
    category: "jewelry",
    subcategory: "Boucles d'oreilles",
    name: "Clips d'oreilles en verre gemme",
    price: "5.99",
    raw_price: "10.99",
    currency: "USD",
    discount: "46",
    likes_count: "107",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6F/B5/05d5cc3e-2a7d-4717-bd33-ff17948d3237.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/earrings-4041/p-1674308.html",
    id: "1674308",
    model: "SKUE92041",
  },
  {
    category: "jewelry",
    subcategory: "Boucles d'oreilles",
    name: "Boucles d'oreilles pendentif pierre de lune",
    price: "6.99",
    raw_price: "14",
    currency: "USD",
    discount: "50",
    likes_count: "222",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "",
    variation_0_color: "Silver",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/FD/C4/38aee6f1-2e3f-40ba-b49c-7edb3ded8fc1.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/FD/C4/38aee6f1-2e3f-40ba-b49c-7edb3ded8fc1.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/9D/96/260c5ec5-6f7e-46ac-9dc4-2718fa320701.jpg",
    url: "https://fr.newchic.com/earrings-4041/p-1659984.html",
    id: "1659984",
    model: "SKUE74916",
  },
  {
    category: "jewelry",
    subcategory: "Bracelets",
    name: "Bracelet multicouche turquoise",
    price: "9.99",
    raw_price: "19.99",
    currency: "USD",
    discount: "50",
    likes_count: "63",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Green",
    variation_1_color: "Blue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/D9/A9/19b34b4f-70a8-451c-959f-20155c58f86e.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D9/A9/19b34b4f-70a8-451c-959f-20155c58f86e.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/0B/7A/edc1c6f3-9370-44e6-8962-1cc07f1e978d.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/0B/7A/edc1c6f3-9370-44e6-8962-1cc07f1e978d.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B3/79/b78f674f-59d3-4b3a-a786-ac291c39f07f.jpg",
    url: "https://fr.newchic.com/bracelets-4043/p-1694693.html",
    id: "1694693",
    model: "SKUF42669",
  },
  {
    category: "jewelry",
    subcategory: "Colliers",
    name: "Collier écharpe triangle en résine",
    price: "13.99",
    raw_price: "29.99",
    currency: "USD",
    discount: "53",
    likes_count: "51",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/23/4C/b23e3267-f777-405a-b1fb-02a4dca5b6f3.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/necklaces-4047/p-1713803.html",
    id: "1713803",
    model: "SKUF64886",
  },
  {
    category: "jewelry",
    subcategory: "Montres connectées",
    name: "L7 Montres intelligentes à écran bord à bord",
    price: "118.77",
    raw_price: "213.41",
    currency: "USD",
    discount: "44",
    likes_count: "94",
    is_new: "false",
    brand: "Microwear",
    brand_url: "https://fr.newchic.com/microwear-brand-1588.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/76/91/03232785-df4a-47b2-8caf-c6018fd0733c.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/microwear-smart-watches-4993/p-1464414.html",
    id: "1464414",
    model: "SKUB99649",
  },
  {
    category: "jewelry",
    subcategory: "Colliers",
    name: "Collier Pendentif Feuille de Bois",
    price: "15.31",
    raw_price: "25.99",
    currency: "USD",
    discount: "41",
    likes_count: "1055",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Comme image",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/78/F2/dfe576a1-82de-44df-97e0-b9168c069cfc.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/78/F2/dfe576a1-82de-44df-97e0-b9168c069cfc.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/97/1C/d82f1e8e-d80f-436a-be53-02faf3776b8c.jpg",
    url: "https://fr.newchic.com/necklaces-4047/p-1326959.html",
    id: "1326959",
    model: "SKU958141",
  },
  {
    category: "jewelry",
    subcategory: "Montres connectées",
    name: "HD Montre intelligente à écran",
    price: "329.99",
    raw_price: "699.99",
    currency: "USD",
    discount: "53",
    likes_count: "30",
    is_new: "false",
    brand: "TICWRIS",
    brand_url: "https://fr.newchic.com/ticwris-brand-2404.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Silver",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/BD/D0/be9b5262-cf07-4389-9db4-726947eed50e.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/BD/D0/be9b5262-cf07-4389-9db4-726947eed50e.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/D6/BA/0421a060-23f8-4b04-85bf-4c891811dbd1.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D6/BA/0421a060-23f8-4b04-85bf-4c891811dbd1.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/0D/09/843bad2d-62a9-4c66-80a3-91b35c40ccf6.jpg",
    url: "https://fr.newchic.com/ticwris-smart-watches-4993/p-1623129.html",
    id: "1623129",
    model: "SKUE39557",
  },
  {
    category: "jewelry",
    subcategory: "Boucles d'oreilles",
    name: "Boucles d'oreilles triangle en pierre du Labrador",
    price: "9.44",
    raw_price: "18.94",
    currency: "USD",
    discount: "50",
    likes_count: "153",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Green",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/BD/0D/8d1d0069-f564-4afe-92b7-b1f30e5d51a0.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/BD/0D/8d1d0069-f564-4afe-92b7-b1f30e5d51a0.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F4/E2/ca619004-2300-4c4f-903b-950ef735afae.jpg",
    url: "https://fr.newchic.com/earrings-4041/p-1659986.html",
    id: "1659986",
    model: "SKUE74911",
  },
  {
    category: "jewelry",
    subcategory: "Bagues",
    name: "Bague topaze carrée Highland",
    price: "9.99",
    raw_price: "0",
    currency: "USD",
    discount: "0",
    likes_count: "92",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "argent",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/5B/96/24fc56a7-9a4e-49a4-b717-c8c454c6c9ac.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/5B/96/24fc56a7-9a4e-49a4-b717-c8c454c6c9ac.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/rings-4048/p-1697500.html",
    id: "1697500",
    model: "SKUF42285",
  },
  {
    category: "jewelry",
    subcategory: "Colliers",
    name: "Collier de pierres précieuses arbre de vie",
    price: "8.99",
    raw_price: "16.99",
    currency: "USD",
    discount: "47",
    likes_count: "54",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/42/7F/56f4cf70-df20-4f05-9c0b-05b09adca8f4.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/necklaces-4047/p-1708238.html",
    id: "1708238",
    model: "SKUF64390",
  },
  {
    category: "jewelry",
    subcategory: "Montres connectées",
    name: "Bande d'origine Xiaomi Mi 5",
    price: "49.99",
    raw_price: "102.99",
    currency: "USD",
    discount: "52",
    likes_count: "19",
    is_new: "false",
    brand: "XIAOMI",
    brand_url: "https://fr.newchic.com/xiaomi-brand-520.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/48/3F/d6fd33bd-e058-442d-8d55-cfde7deab44c.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/48/3F/d6fd33bd-e058-442d-8d55-cfde7deab44c.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/DB/A4/99517295-2f7c-49d3-b67d-63888e827f34.jpg",
    url: "https://fr.newchic.com/xiaomi-smart-watches-4993/p-1693840.html",
    id: "1693840",
    model: "SKUE46510",
  },
  {
    category: "jewelry",
    subcategory: "Colliers",
    name: "Collier boule de verre transparent",
    price: "7.99",
    raw_price: "23.99",
    currency: "USD",
    discount: "67",
    likes_count: "237",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/51/3D/64d4c76d-cce6-463f-ba0a-000bd8d1abc6.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/necklaces-4047/p-1667994.html",
    id: "1667994",
    model: "SKUE92262",
  },
  {
    category: "jewelry",
    subcategory: "Colliers",
    name: "Collier long de perles de Bouddha fait à la main",
    price: "9.99",
    raw_price: "21.99",
    currency: "USD",
    discount: "55",
    likes_count: "76",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/0C/44/dac105e3-9f80-4ec7-ba81-2139c0122728.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/necklaces-4047/p-1693347.html",
    id: "1693347",
    model: "SKUF42621",
  },
  {
    category: "jewelry",
    subcategory: "Boucles d'oreilles",
    name: "Boucles d'oreilles fleur stéréoscopique ",
    price: "17.81",
    raw_price: "29.8",
    currency: "USD",
    discount: "40",
    likes_count: "127",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Silver",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/52/CE/33104d3a-f5d0-4c04-be21-9ed53ce619b9.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/52/CE/33104d3a-f5d0-4c04-be21-9ed53ce619b9.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/earrings-4041/p-1646652.html",
    id: "1646652",
    model: "SKUE32617",
  },
  {
    category: "jewelry",
    subcategory: "Montres pour homme",
    name: "Montre Homme à Cadran Triangle",
    price: "34.49",
    raw_price: "91.98",
    currency: "USD",
    discount: "63",
    likes_count: "20",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "White",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A8/8B/7208ae7f-1507-4d42-b06a-192facf1f4a2.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A8/8B/7208ae7f-1507-4d42-b06a-192facf1f4a2.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/D3/C3/8325bb3c-947b-4d98-ac55-73f2945a1189.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D3/C3/8325bb3c-947b-4d98-ac55-73f2945a1189.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/FB/B8/fe2a3d66-2690-48ff-9686-e16e35d8d31a.jpg",
    url: "https://fr.newchic.com/men-watches-4551/p-1695759.html",
    id: "1695759",
    model: "SKUF34441",
  },
  {
    category: "jewelry",
    subcategory: "Bagues",
    name: "Anneau de minerai de cristal naturel irrégulier",
    price: "9.99",
    raw_price: "19.99",
    currency: "USD",
    discount: "50",
    likes_count: "39",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Silver",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/C5/EA/bd0cf14c-568c-4daf-9860-78a125c8224f.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C5/EA/bd0cf14c-568c-4daf-9860-78a125c8224f.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/96/05/a84ed30c-fa90-4963-9a12-f3b86d2fafe8.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/96/05/a84ed30c-fa90-4963-9a12-f3b86d2fafe8.jpg",
    image_url: "/",
    url: "https://fr.newchic.com/rings-4048/p-1709211.html",
    id: "1709211",
    model: "SKUF44540",
  },
  {
    category: "jewelry",
    subcategory: "Colliers",
    name: "Collier pompon papillon",
    price: "9.99",
    raw_price: "32.99",
    currency: "USD",
    discount: "70",
    likes_count: "54",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Blue",
    variation_1_color: "Pink",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/F4/D8/0ef70dec-33f9-4d86-a6f8-b7cc87ac62d3.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F4/D8/0ef70dec-33f9-4d86-a6f8-b7cc87ac62d3.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/FA/EA/d1188c6a-fd28-49e5-8fd7-8b7372efd9e8.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/FA/EA/d1188c6a-fd28-49e5-8fd7-8b7372efd9e8.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D2/9C/17cbd162-2db3-4876-9318-1e5195aef8df.jpg",
    url: "https://fr.newchic.com/necklaces-4047/p-1689798.html",
    id: "1689798",
    model: "SKUF37843",
  },
  {
    category: "jewelry",
    subcategory: "Boucles d'oreilles",
    name: "Ensemble de boucles d'oreilles pompon Dreamcatcher ",
    price: "6.81",
    raw_price: "15.39",
    currency: "USD",
    discount: "56",
    likes_count: "188",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/11/36/f9cd2627-a0f9-44a3-a078-6971c7363fdb.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/earrings-4041/p-1659990.html",
    id: "1659990",
    model: "SKUE74247",
  },
  {
    category: "jewelry",
    subcategory: "Colliers",
    name: "Ensemble de collier turquoise",
    price: "9.99",
    raw_price: "32.99",
    currency: "USD",
    discount: "70",
    likes_count: "89",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "# 01",
    variation_1_color: "# 02",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/C3/62/d1183ae4-f0ee-4273-aea9-45ec87258cdf.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C3/62/d1183ae4-f0ee-4273-aea9-45ec87258cdf.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/C5/1B/068662ea-aaf8-4057-8346-c15f60a75e39.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C5/1B/068662ea-aaf8-4057-8346-c15f60a75e39.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/20/D3/b984e39b-32fb-48c8-bb02-c3c45eb369a7.jpg",
    url: "https://fr.newchic.com/necklaces-4047/p-1690096.html",
    id: "1690096",
    model: "SKUF37870",
  },
  {
    category: "jewelry",
    subcategory: "Colliers",
    name: "Collier multicouche chaîne en métal",
    price: "9.99",
    raw_price: "32.99",
    currency: "USD",
    discount: "70",
    likes_count: "41",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Bleu clair",
    variation_1_color: "Rose",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/27/A8/1d34eceb-3b3c-42aa-83d7-989b90d5c735.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/27/A8/1d34eceb-3b3c-42aa-83d7-989b90d5c735.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/03/91/f97fa44c-09fb-4713-9526-da4001526442.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/03/91/f97fa44c-09fb-4713-9526-da4001526442.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/9E/53/d1ff697f-5df5-4577-a34f-67c1b0773e6f.jpg",
    url: "https://fr.newchic.com/necklaces-4047/p-1702467.html",
    id: "1702467",
    model: "SKUF52969",
  },
  {
    category: "jewelry",
    subcategory: "Montres connectées",
    name: "Montre intelligente d'activité Fitness Tracker",
    price: "166.96",
    raw_price: "318.02",
    currency: "USD",
    discount: "48",
    likes_count: "387",
    is_new: "false",
    brand: "Bakeey",
    brand_url: "https://fr.newchic.com/bakeey-brand-878.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "argent",
    variation_1_color: "Noir",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/CB/F4/913d8c85-4229-4651-b739-07249a031280.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/CB/F4/913d8c85-4229-4651-b739-07249a031280.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/DC/6B/618aef4d-913e-478e-b4eb-644f1bf7da2d.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/DC/6B/618aef4d-913e-478e-b4eb-644f1bf7da2d.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E4/55/d0d4b758-4c19-4bb8-a337-e469a2b195d0.gif",
    url: "https://fr.newchic.com/bakeey-smart-watches-4993/p-1362450.html",
    id: "1362450",
    model: "SKUA51107",
  },
  {
    category: "jewelry",
    subcategory: "Boucles d'oreilles",
    name: "Boucles d'oreilles irrégulières en pierre naturelle",
    price: "6.99",
    raw_price: "19.99",
    currency: "USD",
    discount: "65",
    likes_count: "29",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "vert",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/2A/06/98a67c78-6bc2-4087-af65-c3dd83e12a2d.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/2A/06/98a67c78-6bc2-4087-af65-c3dd83e12a2d.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/earrings-4041/p-1696446.html",
    id: "1696446",
    model: "SKUF42292",
  },
  {
    category: "jewelry",
    subcategory: "Colliers",
    name: "Collier poisson stéréoscopique",
    price: "10.99",
    raw_price: "22.99",
    currency: "USD",
    discount: "52",
    likes_count: "59",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Bleu",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A4/F9/c15962f4-937f-478c-ae56-0076a2341e15.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A4/F9/c15962f4-937f-478c-ae56-0076a2341e15.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/3E/15/b2acad4a-bf80-44bf-9bcf-2b6481fd0563.jpg",
    url: "https://fr.newchic.com/necklaces-4047/p-1694698.html",
    id: "1694698",
    model: "SKUF42778",
  },
  {
    category: "jewelry",
    subcategory: "Montres connectées",
    name: "Moniteur d'activité Affichage des messages Montre intelligente",
    price: "48.08",
    raw_price: "91.58",
    currency: "USD",
    discount: "48",
    likes_count: "314",
    is_new: "false",
    brand: "Bakeey",
    brand_url: "https://fr.newchic.com/bakeey-brand-878.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "1",
    variation_1_color: "2",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/C2/BB/8932c31b-1a30-406f-a11f-ad1f372e5c2a.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C2/BB/8932c31b-1a30-406f-a11f-ad1f372e5c2a.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/08/96/baaf51b3-2c08-49b5-87be-9ab5e1c9d43a.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/08/96/baaf51b3-2c08-49b5-87be-9ab5e1c9d43a.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A8/95/3870b02e-6703-41b9-ac78-489a44a9ae37.gif",
    url: "https://fr.newchic.com/bakeey-smart-watches-4993/p-1457649.html",
    id: "1457649",
    model: "SKUB74729",
  },
  {
    category: "jewelry",
    subcategory: "Colliers",
    name: "Collier long de perles de bois de Bouddha",
    price: "11.99",
    raw_price: "22.99",
    currency: "USD",
    discount: "48",
    likes_count: "25",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/86/EB/76dfffd0-0cb6-4593-959c-e39e2c744e13.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/necklaces-4047/p-1701792.html",
    id: "1701792",
    model: "SKUF52961",
  },
  {
    category: "jewelry",
    subcategory: "Boucles d'oreilles",
    name: "Colorful Boucles d'oreilles à motif d'oiseaux",
    price: "9.49",
    raw_price: "18.49",
    currency: "USD",
    discount: "49",
    likes_count: "105",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Gold",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/10/31/cbb343bc-48c7-44df-97ad-9c87caefe33d.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/10/31/cbb343bc-48c7-44df-97ad-9c87caefe33d.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/AB/B3/b997293a-9a46-4167-8149-693ee24a016f.jpg",
    url: "https://fr.newchic.com/earrings-4041/p-1681863.html",
    id: "1681863",
    model: "SKUF26133",
  },
  {
    category: "jewelry",
    subcategory: "Bracelets",
    name: "Bracelet tressé libellule bleue",
    price: "6.99",
    raw_price: "15.98",
    currency: "USD",
    discount: "56",
    likes_count: "38",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Bleu",
    variation_1_color: "blanc",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A4/5A/44e6325a-4b18-4abd-99f8-95f527cc7b2f.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A4/5A/44e6325a-4b18-4abd-99f8-95f527cc7b2f.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/99/36/10d8d2e5-6fc6-4475-94da-6244c301501c.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/99/36/10d8d2e5-6fc6-4475-94da-6244c301501c.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/4A/68/11db852d-5bfa-425d-a1f2-384a7e8e4372.jpg",
    url: "https://fr.newchic.com/bracelets-4043/p-1707997.html",
    id: "1707997",
    model: "SKUF64496",
  },
  {
    category: "jewelry",
    subcategory: "Boucles d'oreilles",
    name: "Boucles d'oreilles asymétriques turquoise",
    price: "10.99",
    raw_price: "21.99",
    currency: "USD",
    discount: "50",
    likes_count: "60",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "vert",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A2/D6/604a1d12-f4c7-44c8-9cfa-ada26423e74a.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A2/D6/604a1d12-f4c7-44c8-9cfa-ada26423e74a.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/earrings-4041/p-1696972.html",
    id: "1696972",
    model: "SKUF42310",
  },
  {
    category: "jewelry",
    subcategory: "Bracelets",
    name: "Bracelet multicouche tournesol",
    price: "6.99",
    raw_price: "13.98",
    currency: "USD",
    discount: "50",
    likes_count: "34",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Bleu",
    variation_1_color: "blanc",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/AB/2C/9e01e457-7f01-4501-8a91-5e51057d30b0.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/AB/2C/9e01e457-7f01-4501-8a91-5e51057d30b0.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/99/D7/bb546b99-43da-4859-aaa7-13c9cd987912.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/99/D7/bb546b99-43da-4859-aaa7-13c9cd987912.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6C/F0/e7a88a27-9a80-4be4-9387-257f27873b6a.jpg",
    url: "https://fr.newchic.com/bracelets-4043/p-1708019.html",
    id: "1708019",
    model: "SKUF64234",
  },
  {
    category: "jewelry",
    subcategory: "Montres connectées",
    name: "Blood Pressure Smart Bande",
    price: "32.76",
    raw_price: "56.99",
    currency: "USD",
    discount: "43",
    likes_count: "37",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Dark Blue",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/4A/8D/272630e8-afd8-44cb-9a70-8c3e63d86151.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/4A/8D/272630e8-afd8-44cb-9a70-8c3e63d86151.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/14/72/5955e64c-e629-405c-bcee-d2115f40e1ef.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/14/72/5955e64c-e629-405c-bcee-d2115f40e1ef.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D3/80/367f5933-f56b-4d47-a60f-8a594be7ce23.jpg",
    url: "https://fr.newchic.com/smart-watches-4993/p-1659734.html",
    id: "1659734",
    model: "SKUE89204",
  },
  {
    category: "jewelry",
    subcategory: "Bracelets",
    name: "Bracelet marguerite ethnique ",
    price: "6.81",
    raw_price: "15.39",
    currency: "USD",
    discount: "56",
    likes_count: "108",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "White",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A3/BC/0d9fdee6-e2c7-429e-b4ec-9e1d0484aba4.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A3/BC/0d9fdee6-e2c7-429e-b4ec-9e1d0484aba4.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/bracelets-4043/p-1667999.html",
    id: "1667999",
    model: "SKUE91693",
  },
  {
    category: "jewelry",
    subcategory: "Boucles d'oreilles",
    name: "Boucles d'oreilles en verre métal Colorful",
    price: "7.99",
    raw_price: "14.99",
    currency: "USD",
    discount: "47",
    likes_count: "75",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Silver",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/0F/CD/571d84a5-75a7-4558-b5df-007398504a60.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/0F/CD/571d84a5-75a7-4558-b5df-007398504a60.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/8A/0E/9af2275e-84c7-4909-897c-4d4714e89383.jpg",
    url: "https://fr.newchic.com/earrings-4041/p-1674305.html",
    id: "1674305",
    model: "SKUE83640",
  },
  {
    category: "jewelry",
    subcategory: "Bracelets",
    name: "Bracelet double marguerite",
    price: "19.99",
    raw_price: "39.99",
    currency: "USD",
    discount: "50",
    likes_count: "113",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Silver",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/B7/B9/f25ce527-4e5f-4163-8168-c81553dbf8e7.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B7/B9/f25ce527-4e5f-4163-8168-c81553dbf8e7.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/91/BB/afcf53ab-5d44-4784-a703-48f521fdd7bb.jpg",
    url: "https://fr.newchic.com/bracelets-4043/p-1667995.html",
    id: "1667995",
    model: "SKUE91994",
  },
  {
    category: "jewelry",
    subcategory: "Colliers",
    name: "Collier multicouche en mousseline de soie à pompons de perles",
    price: "15.99",
    raw_price: "30.99",
    currency: "USD",
    discount: "48",
    likes_count: "27",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/BC/F5/e4be1b5c-c1aa-472b-9e33-8072e6a15530.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/necklaces-4047/p-1713784.html",
    id: "1713784",
    model: "SKUF64889",
  },
  {
    category: "jewelry",
    subcategory: "Colliers",
    name: "Sautoir Perles en Bois",
    price: "14.99",
    raw_price: "28.99",
    currency: "USD",
    discount: "48",
    likes_count: "14",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Rose rouge",
    variation_1_color: "Violet",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/EB/9D/64bbe135-25dc-41cc-acb9-3f16a5b6b161.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/EB/9D/64bbe135-25dc-41cc-acb9-3f16a5b6b161.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/B9/8A/6f6062c0-c916-460e-b0df-119818643e3e.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B9/8A/6f6062c0-c916-460e-b0df-119818643e3e.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/19/FA/01091424-56a4-41e5-bddc-eee7f814c3aa.jpg",
    url: "https://fr.newchic.com/necklaces-4047/p-1690079.html",
    id: "1690079",
    model: "SKUF37873",
  },
  {
    category: "jewelry",
    subcategory: "Accessoires des cheveux",
    name: "Bandeau de broderie bohème",
    price: "8.99",
    raw_price: "14.99",
    currency: "USD",
    discount: "40",
    likes_count: "67",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F7/DA/60358e83-3ed8-486c-8afa-f786f4dd7c4c.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/hair-accessories-5139/p-1681419.html",
    id: "1681419",
    model: "SKUF16205",
  },
  {
    category: "jewelry",
    subcategory: "Montres pour homme",
    name: "Petites montres pour hommes à trois aiguilles",
    price: "12.99",
    raw_price: "25.98",
    currency: "USD",
    discount: "50",
    likes_count: "13",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir + Rouge",
    variation_1_color: "Noir + Bleu",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/88/62/e0023294-cafe-4c2d-9291-639bb341b56d.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/88/62/e0023294-cafe-4c2d-9291-639bb341b56d.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/92/20/eb164626-f33e-4325-8ae8-e425d88a3dc5.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/92/20/eb164626-f33e-4325-8ae8-e425d88a3dc5.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/CF/5A/ae6f5377-8ba4-4a6e-8b09-da82ffbc9e62.jpg",
    url: "https://fr.newchic.com/men-watches-4551/p-1712835.html",
    id: "1712835",
    model: "SKUF56604",
  },
  {
    category: "jewelry",
    subcategory: "Boucles d'oreilles",
    name: "Boucles d'oreilles Fleurs Datura ",
    price: "5.99",
    raw_price: "10.99",
    currency: "USD",
    discount: "46",
    likes_count: "66",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Silver",
    variation_1_color: "Gold",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/88/4D/066c8433-f113-4174-95e5-53b9a2863b9e.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/88/4D/066c8433-f113-4174-95e5-53b9a2863b9e.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/CA/A0/6f68ff47-768b-457e-b8b4-f26b5cb09e6a.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/CA/A0/6f68ff47-768b-457e-b8b4-f26b5cb09e6a.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B3/9A/3ccde7b2-7f60-4e63-8c7d-5d5f2405e91f.jpg",
    url: "https://fr.newchic.com/earrings-4041/p-1674307.html",
    id: "1674307",
    model: "SKUE92016",
  },
  {
    category: "jewelry",
    subcategory: "Colliers",
    name: "Collier hibou carré en verre",
    price: "10.99",
    raw_price: "21.99",
    currency: "USD",
    discount: "50",
    likes_count: "26",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/3C/4A/30daf321-a6d4-4fde-b49e-cebad5f6e7be.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/necklaces-4047/p-1708186.html",
    id: "1708186",
    model: "SKUF64388",
  },
  {
    category: "jewelry",
    subcategory: "Boucles d'oreilles",
    name: "Ensemble de boucles d'oreilles ailes géométriques ",
    price: "11.54",
    raw_price: "20.77",
    currency: "USD",
    discount: "44",
    likes_count: "67",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/35/24/94b5bdaf-8da1-40c9-bb35-d338f5d5a136.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/earrings-4041/p-1654135.html",
    id: "1654135",
    model: "SKUE74291",
  },
  {
    category: "jewelry",
    subcategory: "Colliers",
    name: "Collier pompon perlé à la main papillon",
    price: "12.99",
    raw_price: "24.99",
    currency: "USD",
    discount: "48",
    likes_count: "13",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "kaki",
    variation_1_color: "Bleu clair",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/F9/43/a0084eca-2a8d-4053-9cfb-66734bbc094a.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F9/43/a0084eca-2a8d-4053-9cfb-66734bbc094a.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/F1/0C/17355870-cace-4aec-bdc2-f7a4b461c90b.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F1/0C/17355870-cace-4aec-bdc2-f7a4b461c90b.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/12/78/17452a0f-3cb0-4fb0-99f5-93f8907504de.jpg",
    url: "https://fr.newchic.com/necklaces-4047/p-1701904.html",
    id: "1701904",
    model: "SKUF52963",
  },
  {
    category: "jewelry",
    subcategory: "Montres pour homme",
    name: "Montre Sports Luminous Hommes",
    price: "55.99",
    raw_price: "111.98",
    currency: "USD",
    discount: "50",
    likes_count: "11",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Blue+Rose Gold",
    variation_1_color: "Bleu + Argent",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/2B/8A/02d8915f-ea24-4570-80b4-515d4114efbd.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/2B/8A/02d8915f-ea24-4570-80b4-515d4114efbd.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/63/70/e5093a67-0805-421f-9b3c-48bc561787e9.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/63/70/e5093a67-0805-421f-9b3c-48bc561787e9.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/97/DA/21f94ac7-bb22-41f3-bf59-5966b4e1116c.gif",
    url: "https://fr.newchic.com/men-watches-4551/p-1707658.html",
    id: "1707658",
    model: "SKUF46408",
  },
];

export default Jewelry;
